<h3 [innerHTML]="profileText.heading"></h3>
<div [innerHTML]="profileText.mainText" class="id37-text2 text-light"></div>
